<template>
  <div class="basket-form-legal-entity-details text-center">
    <div class="d-flex justify-center align-center">
<!--      <button v-if="isCloseButtonShown" class="basket-form-legal-entity-details__close" @click="onCloseButtonClick">
        <svgicon name="cross"/>
      </button>-->
      <h4>Укажите реквизит<span @click.ctrl="fillForm">ы</span></h4>
    </div>
    <v-row class="mt-2">
      <v-col v-for="field in fields" cols="12" sm="4" :key="'field-' + field.ID">
        <v-text-field v-model="form[field.CODE]"
                      :label="field.NAME"
                      maxlength="200"
                      :required="field.REQUIED === 'Y'" />
      </v-col>
    </v-row>
    <v-row v-if="legalEntityCommentText" class="mt-2">
      <v-col cols="12">
        <div class="size1" v-html="legalEntityCommentText"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {DESTINATION_RUSSIA} from "@/store/delivery";
import {PAYMENT_SYSTEM_ID_DEFERRED} from "@/store/payment";

export default {
  name: "basket-form-legal-entity-details",
  components: {},
  props: {
    form: {},
    fields: {},
  },
  data() {
    return {}
  },
  computed: {
    legalEntityCommentText() {
      return this.$store.state.page?.BasketController?.settings?.LEGAL_ENTITY_COMMENT?.DETAIL_TEXT;
    },
    isCloseButtonShown() {
      return this.form.destinationId === DESTINATION_RUSSIA;
    }
  },
  methods: {
    onCloseButtonClick() {
      this.form.paymentSystemId = PAYMENT_SYSTEM_ID_DEFERRED;
    },
    fillForm() {
      this.fields.forEach((field) => {
        this.form[field.CODE] = 'test';
      });
    }
  },
}
</script>

<style lang="scss">
.basket-form-legal-entity-details {
  &__close {
    margin-right: 8px;

    &:hover {
      svg {
        stroke: $black;
      }
    }

    svg {
      fill: none;
      stroke: $golden;
      width: 12px;
      height: 12px;
      margin-top: -2px;
      @include transition();
    }
  }
}
</style>